<template lang="pug">
v-dialog(
    :value="value"
    :max-width="maxWidth"
    :scrollable="scrollable"
    :fullscreen="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs"
    :content-class="scrollable? undefined : 'overflow-visible'"
    :transition="false"
    @input="$emit('input', $event)"
    persistent )
    slot(name="content")
        v-card(height="100%")
            v-card-title.headline(:class="{'justify-center': titleCenter}") {{ title }}
            v-card-text(
                :style="{ maxHeight: scrollable ? scrollContentHeight : undefined }"
                :class="{'text-center': textCenter}" )
                slot

            v-card-actions
                slot(name="footer")
                v-spacer
                slot(name="actions")
                    cancel-button(v-if="cancelButton" :text="cancelText" @cancel="$emit('cancel'); $emit('input', false)")
                    ok-button(v-if="okButton" :color="okColor" :loading="okLoading" :disabled="okDisabled" :text="okText" @ok="$emit('ok')")

            overlay.modal-overlay(v-if="showOverlay" :show="true")
</template>

<script>
import Overlay from '@/components/overlay/Overlay'
import CancelButton from './CancelButton'
import OkButton from './OkButton'

export default {
    components: {
        Overlay,
        CancelButton,
        OkButton,
    },
    props: {
        value: {
            type: Boolean,
        },
        showOverlay: {
            type: Boolean,
        },
        title: {
            type: String,
            default: null,
        },
        titleCenter: {
            type: Boolean,
            default: false,
        },
        textCenter: {
            type: Boolean,
            default: false,
        },
        scrollable: {
            type: Boolean,
            default: false,
        },
        cancelButton: {
            type: Boolean,
            default: false,
        },
        cancelText: {
            type: String,
            default: null,
        },
        okButton: {
            type: Boolean,
            default: true,
        },
        okLoading: {
            type: Boolean,
        },
        okDisabled: {
            type: Boolean,
            default: false,
        },
        okText: {
            type: String,
            default: null,
        },
        okColor: {
            type: String,
            default: null,
        },
        maxWidth: {
            type: [Number, String],
            default: 500,
        },
        scrollContentHeight: {
            type: String,
            default: '60vh',
        },
    },
    watch: {
        value(value) {
            this.$emit(value ? 'open' : 'close')
        },
    },
}
</script>

<style lang="scss">
.modal-overlay {
    position: absolute !important;
    width: 100%;
    height: 100%;
    top: 0;
}
</style>
